import {
  VIEW_JOB_LIST_REQUEST, VIEW_JOB_LIST_FAIL, VIEW_JOB_LIST_SUCCESS
} from "../constants/AuthConstant";

const initialState = {
  loading: true,
  action: "Job Action",
  result: null,
  msg: "",
  error: "",
};

const ViewJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case VIEW_JOB_LIST_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case VIEW_JOB_LIST_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case VIEW_JOB_LIST_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default ViewJobReducer;
